import React, { useMemo, useEffect, useState } from "react";
import {
    CheckboxGroup, DateRangePicker, Form, FormGroup, SelectPicker,
    CheckPicker, FormControl, ControlLabel, Input, Checkbox
} from "rsuite";
import styled from "styled-components";

import { difference, servicePick, removeNilValues, toUTCDateTime, compareObjects, compareTwoArrays } from "utils";
import { SCREEN_MEDIA } from "const";
import FormHOC from "hoc/FilltersForm";
import { usePrevious } from "hooks";
import DateTimeRangePicker from "components/DateRangePicker/DateTimerRangePicker";
import CheckboxBadge from "components/Form/CheckboxBadge/CheckboxBadge";
import { ButtonPrimary } from "components/base/BaseButton";
import CustomField from "components/Form/CustomField";
import Text from "components/Form/Text";
import { FilterSectionFlexboxGrid, StyledItemAutoMargin, StyledItemFitWidth } from "components/base/FitContainers";

const { mx } = SCREEN_MEDIA;


const FullReportFilters = ({
    sort,
    defaultSort,
    defaultFilters,
    currentFilters,
    loading,
    preFilters,
    globalSettings = {},
    service,
    isMobile,

    reasonList,
    dialerList,
    countryList,
    supplierList,
    originatorList,
    servicePlanList,
    accountManagerList,
    subdestinationList,
    accountManagerBilList,

    getReferencesForReports,

    getAccountManagersBillingList,
    getAccountManagersDropdownList,

    setSort,
    setPreFilters,
    onApplyFilters,
    ...props
}) => {

    const defaultValues = {
        ...defaultFilters,
        operator: null,
        cntr_key_list: null,
        supplier_id_list: null,
        supplier_trunk_id_list: [],
        originator_key_list: null,
        account_manager_id_list: null,
        dialer_id_list: null,
        sp_key_list: null,
        sender_sde_key_list: null,
        phone_sde_key_list: null,
        senderid: null,
        mcc_mnc: null,
        dialer_manager_id_list: null,
        group_checkbox: [],
        only_my_account: true,
        show_accepted: true,
        show_rejected: false
    };

    const [filters, setFilters] = useState(currentFilters);
    const [grouping, setGrouping] = useState(currentFilters.group_checkbox);
    const [onlyMyAccountCheck, setOnlyMyAccountCheck] = useState(defaultValues.only_my_account);
    const [showAccepted, setShowAccepted] = useState(defaultValues.show_accepted);
    const [showRejected, setShowRejected] = useState(defaultValues.show_rejected);
    const [pickedSupplier, setPickedSupplier] = useState(null);
    const [pickedSupplierTrunkList, setPickedSupplierTrunkList] = useState([]);
    const [secondUpdateFixer, setSecondUpdateFixer] = useState(null);

    useEffect(() => {
        setFilters(defaultValues);

        const preDefaultFilterValues = { ...defaultValues };

        if (preDefaultFilterValues.range && preDefaultFilterValues.range.length) {
            // filterValues["start_date"] = toStartDayUTCTime(filterValues.range[0]);
            // filterValues["end_date"] = toEndDayUTCTime(filterValues.range[1]);
            preDefaultFilterValues["start_date"] = toUTCDateTime(preDefaultFilterValues.range[0]);
            preDefaultFilterValues["end_date"] = toUTCDateTime(preDefaultFilterValues.range[1]);

            delete preDefaultFilterValues.range;
        }

        setPreFilters(removeNilValues(preDefaultFilterValues))

        setOnlyMyAccountCheck(defaultValues.only_my_account);
        setShowAccepted(defaultValues.show_accepted);
        setShowRejected(defaultValues.show_rejected);

        setGrouping(defaultValues?.group_checkbox);
        setSecondUpdateFixer(null);
    }, []);

    const handleChange = (formValues) => {
        const filterValues = { ...formValues };
        let groupCheckboxes = filterValues.group_checkbox;
        const radioCheckboxes = ["dt_hour", "dt_day", "dt_month", "dt_year"];
        const mccMncCheckboxes = ["mcc", "mcc_mnc"];
        const changedCheckbox = difference(groupCheckboxes, grouping)[0];

        const valuesWithoutRadio1 = groupCheckboxes.filter((el) => !radioCheckboxes.includes(el));

        if (changedCheckbox && radioCheckboxes.includes(changedCheckbox)) {
            groupCheckboxes = [...valuesWithoutRadio1, changedCheckbox];
        }

        const valuesWithoutRadio2 = groupCheckboxes.filter((el) => !mccMncCheckboxes.includes(el));

        if (changedCheckbox && mccMncCheckboxes.includes(changedCheckbox)) {
            groupCheckboxes = [...valuesWithoutRadio2, changedCheckbox];
        }

        if (!service && !groupCheckboxes.includes("supplier_name")) {
            if (groupCheckboxes.includes("supplier_trunk")) {
                const index = groupCheckboxes.indexOf("supplier_trunk");
                groupCheckboxes.splice(index, 1);
            }
        }

        setGrouping(groupCheckboxes);

        const supplierIdListKey = servicePick(service, "supplier_key_list", "supplier_id_list");

        if (!service && (
            !formValues[supplierIdListKey] ||
            supplierIdListKey in formValues && supplierIdListKey in filterValues &&
            !compareTwoArrays(formValues[supplierIdListKey], filterValues[supplierIdListKey]) ||
            formValues[supplierIdListKey] && formValues[supplierIdListKey].length === 0 ||
            formValues[supplierIdListKey] && formValues[supplierIdListKey].length > 1
        )) {
            if ("supplier_trunk_id_list" in filterValues) {
                delete filterValues.supplier_trunk_id_list;
                setPickedSupplierTrunkList([]);
            }
        }

        setFilters({ ...filterValues, group_checkbox: groupCheckboxes });

        if (filterValues.range && filterValues.range.length) {
            // filterValues["start_date"] = toStartDayUTCTime(filterValues.range[0]);
            // filterValues["end_date"] = toEndDayUTCTime(filterValues.range[1]);
            filterValues["start_date"] = toUTCDateTime(filterValues.range[0]);
            filterValues["end_date"] = toUTCDateTime(filterValues.range[1]);

            delete filterValues.range;
        }

        if (
            !compareObjects(sort, defaultSort) &&
            (!!filterValues.group_checkbox?.length &&
                !filterValues.group_checkbox.includes(sort.column) ||
                !filterValues.group_checkbox?.length)
        ) {
            setSort(defaultSort);
        }

        setPreFilters(removeNilValues({ ...filterValues, group_checkbox: groupCheckboxes }));
    };

    const handleApply = () => {
        onApplyFilters(removeNilValues(preFilters));
    };

    const checkOnlyAccount = (checked) => {
        setFilters((value) => {
            return {
                ...value,
                only_my_account: checked
            };
        });
        setPreFilters((preValue) => {
            return {
                ...preValue,
                only_my_account: checked
            };
        });
        setOnlyMyAccountCheck(checked);
    };

    const checkReliability = (name, checked) => {
        setFilters((value) => ({ ...value, [name]: checked }));
        setPreFilters((value) => ({ ...value, [name]: checked }));
    };

    useEffect(() => {
        getReferencesForReports();

        if (service) {
            getAccountManagersBillingList();
        }

        getAccountManagersDropdownList({}, true); // !service
    }, [service]);

    const handleChangeDateTime = (value) => {
        const filter = { ...value };
        const currentDatetimeFilter = { range: [filter.range[0], filter.range[1]] };

        const filtersToUpdate = {
            ...filters,
            ...filter,
            ...currentDatetimeFilter
        };

        setFilters(filtersToUpdate);

        const filterValues = { ...filtersToUpdate };

        if (filterValues.range && filterValues.range.length) {
            filterValues["start_date"] = toUTCDateTime(filterValues.range[0]);
            filterValues["end_date"] = toUTCDateTime(filterValues.range[1]);

            delete filterValues.range;
        }

        setPreFilters(removeNilValues(filterValues));
    };

    const accountManagersFiltered = accountManagerList.filter(value => value.active || value.has_accounts);
    const normalizedReasonList = reasonList && reasonList.length ? reasonList.map((reason, idx) => { return { name: reason, key: reason } }) : [];

    const filterFields = useMemo(() => {
        return <FilterFields>
            <DateTimeRangePicker
                onChange={(value) => {
                    handleChangeDateTime(value);
                }}
                defaultStartDate={defaultFilters.range[0]}
                defaultEndDate={defaultFilters.range[1]}
                startDate={filters?.range[0]}
                endDate={filters?.range[1]}
                showRanges
            />
            <CustomField
                accepter={CheckPicker}
                data={supplierList}
                onChange={(supplierIdList) => {
                    if (supplierIdList && supplierIdList.length === 1) {
                        const foundSupplier = supplierList.find(supplier => supplier.id === supplierIdList[0]);
                        setPickedSupplier(foundSupplier || null);
                    } else {
                        setPickedSupplier(null);
                    }
                }}
                labelKey="name"
                valueKey="id"
                placeholder="Suppliers"
                name={servicePick(service, "supplier_key_list", "supplier_id_list")}
                width={200}
                menuStyle={{
                    width: 320
                }}
            />
            <CustomField
                accepter={CheckPicker}
                data={pickedSupplier?.supplier_trunk_list || []}
                onChange={(supplierTrunkIdList) => {
                    setPickedSupplierTrunkList(supplierTrunkIdList);
                }}
                value={pickedSupplierTrunkList}
                labelKey="name"
                valueKey="id"
                placeholder="Supplier trunks"
                name="supplier_trunk_id_list"
                width={200}
                searchable={false}
                disabled={!pickedSupplier}
            />
            <CustomField
                accepter={CheckPicker}
                data={accountManagersFiltered}
                labelKey="name"
                valueKey="id"
                placeholder="Supplier AMs"
                name="supplier_manager_id_list"
                width={200}
                menuStyle={{
                    width: 280
                }}
            />
            <CustomField
                accepter={CheckPicker}
                labelKey="name"
                valueKey="cntr_key"
                data={countryList}
                placeholder="Countries"
                name="cntr_key_list"
                width={200}
                menuStyle={{
                    width: 280
                }}
            />
            <Text
                name="operator"
                placeholder="Operator"
                width={150}
                value={filters.operator}
            />
            <CustomField
                accepter={Input}
                width={120}
                placeholder="MCC/MNC"
                name="mcc_mnc"
            />
            <CustomField
                accepter={CheckPicker}
                data={dialerList}
                value={filters.dialer_id}
                labelKey="name"
                valueKey="id"
                placeholder="Dialers"
                name="dialer_id_list"
                width={200}
                menuStyle={{
                    width: 360
                }}
            />
            {/* <br /> */}
            <CustomField
                accepter={CheckPicker}
                data={servicePlanList}
                value={filters.sp_key_list}
                labelKey="name"
                valueKey="sp_key"
                placeholder="Trunk types"
                name="sp_key_list"
                width={140}
                searchable={false}
            />
            <CustomField
                accepter={CheckPicker}
                data={accountManagersFiltered}
                labelKey="name"
                valueKey="id"
                placeholder="Dialer AMs"
                name="dialer_manager_id_list"
                width={200}
            />
            <CustomField
                accepter={Input}
                width={150}
                placeholder="Sender ID"
                name="senderid"
            />
            <CustomField
                accepter={CheckPicker}
                width={200}
                data={subdestinationList}
                labelKey="name"
                valueKey="sde_key"
                placeholder="Origins"
                name={servicePick(service, "a_sde_key_list", "sender_sde_key_list")}
                menuStyle={{
                    width: 360
                }}
            />
            <CustomField
                accepter={CheckPicker}
                width={200}
                data={subdestinationList}
                labelKey="name"
                valueKey="sde_key"
                placeholder="Destinations"
                name={servicePick(service, "b_sde_key_list", "phone_sde_key_list")}
                menuStyle={{
                    width: 360
                }}
            />
            <CustomField
                accepter={Input}
                width={150}
                placeholder="B-Number"
                name="b_number"
            />
            <CustomField
                accepter={CheckPicker}
                width={300}
                data={normalizedReasonList}
                labelKey="name"
                valueKey="key"
                placeholder="Reason"
                name="reason_list"
                menuStyle={{
                    width: 320
                }}
            />
            <Checkbox
                name="only_my_account"
                onChange={(value, checked) => {
                    checkOnlyAccount(checked);
                }}
                checked={onlyMyAccountCheck}
                style={{ width: 240, display: "inline-block" }}
            >
                Show only my account traffic
            </Checkbox>
            <Checkbox
                name="show_reliable"
                onChange={(_, checked) => checkReliability("show_reliable", checked)}
                checked={filters.show_reliable}
                style={{ width: 130, display: "inline-block" }}
            >
                Show trusted
            </Checkbox>
            <Checkbox
                name="show_not_reliable"
                onChange={(_, checked) => checkReliability("show_not_reliable", checked)}
                checked={filters.show_not_reliable}
                style={{ width: 145, display: "inline-block" }}
            >
                Show untrusted
            </Checkbox>
        </FilterFields >;
    }, [filters, secondUpdateFixer, supplierList, dialerList, subdestinationList, originatorList]);

    const groups = <FormControl
        name="group_checkbox"
        accepter={CheckboxGroup}
        inline
        value={grouping}
    >
        <CheckboxBadge value="dt_hour" noPlus>Hour</CheckboxBadge>
        <CheckboxBadge value="dt_day" noPlus>Day</CheckboxBadge>
        <CheckboxBadge value="dt_month" noPlus>Month</CheckboxBadge>
        <CheckboxBadge value="dt_year" noPlus wrapperClassName={"mr-5"}>Year</CheckboxBadge>
        <CheckboxBadge value="supplier_name" noPlus>Supplier</CheckboxBadge>
        <CheckboxBadge value="supplier_trunk" disabled={!grouping.includes("supplier_name")}>Supplier trunk</CheckboxBadge>
        <CheckboxBadge value="supplier_manager" noPlus>Supplier AM</CheckboxBadge>
        <CheckboxBadge value="supplier_rate" noPlus>Supplier Rate</CheckboxBadge>
        <CheckboxBadge value="originator_name" noPlus>Originator</CheckboxBadge>
        <CheckboxBadge value="dialer_name" noPlus>Dialer</CheckboxBadge>
        <CheckboxBadge value="service_plan_name" noPlus>Dialer Trunk</CheckboxBadge>
        <CheckboxBadge value="dialer_manager" noPlus>Dialer AM</CheckboxBadge>
        <CheckboxBadge value="dialer_rate" noPlus>Dialer Rate</CheckboxBadge>
        {/* <br /> */}

        <CheckboxBadge value="dialer_is_reliable" noPlus>Trusted</CheckboxBadge>
        <CheckboxBadge value="country" noPlus>Country</CheckboxBadge>
        <CheckboxBadge value="operator" noPlus>Operator</CheckboxBadge>
        <CheckboxBadge value="mcc" noPlus>MCC</CheckboxBadge>
        <CheckboxBadge value="mcc_mnc" noPlus>MCC/MNC</CheckboxBadge>
        <CheckboxBadge value="range_name" noPlus>Range</CheckboxBadge>
        <CheckboxBadge value="phone" noPlus>B-Number</CheckboxBadge>
        <CheckboxBadge value="senderid" noPlus>Sender ID</CheckboxBadge>
        <CheckboxBadge value="sender_wz_name" noPlus>Zone (origin)</CheckboxBadge>
        <CheckboxBadge value="sender_de_name" noPlus>Dest (origin)</CheckboxBadge>
        <CheckboxBadge value="sender_sde_name" noPlus>Subdest (origin)</CheckboxBadge>
        <CheckboxBadge value="phone_wz_name" noPlus>Zone (dest)</CheckboxBadge>
        <CheckboxBadge value="phone_de_name" noPlus>Dest (dest)</CheckboxBadge>
        <CheckboxBadge value="phone_sde_name" noPlus>Subdest (dest)</CheckboxBadge>

        <CheckboxBadge value="delivery_status" noPlus>Delivery Status</CheckboxBadge>
        <CheckboxBadge value="reason" noPlus>Reason</CheckboxBadge>
    </FormControl>;

    return (
        <>
            <StyledForm
                layout="inline"
                onChange={handleChange}
                formDefaultValue={defaultFilters}
                formValue={filters}
            >
                {filterFields}
                <GroupsContainer>
                    {groups}
                </GroupsContainer>

                <FilterSectionFlexboxGrid className="flex-filters" controlable={!isMobile}>
                    <StyledItemFitWidth isMobile={isMobile} controlable={!isMobile} noWrap mr={10}>
                        <Checkbox
                            name="show_accepted"
                            onChange={(_, checked) => {
                                setShowAccepted(checked);
                            }}
                            checked={showAccepted}
                            style={{ width: 160, display: "inline-block" }}
                        >Show accepted</Checkbox>
                        <Checkbox
                            name="show_rejected"
                            onChange={(_, checked) => {
                                setShowRejected(checked);
                            }}
                            checked={showRejected}
                            style={{ display: "inline-block" }}
                        >Show rejected</Checkbox>
                    </StyledItemFitWidth>
                    <StyledItemAutoMargin>
                        <ButtonPrimary
                            style={{ padding: "10px 32px" }}
                            onClick={handleApply}
                            disabled={loading}
                        >
                            Apply filters
                        </ButtonPrimary>
                    </StyledItemAutoMargin>
                </FilterSectionFlexboxGrid>
            </StyledForm>
        </>
    );
};

export default FormHOC(FullReportFilters);

const StyledForm = styled(Form)`
    && {
        .flex-filters {
            margin-right: 0px;
            margin-bottom: 10px;
            margin-top: 15px;
        }
    }
`;
const FormGroupRight = styled(FormGroup)`
    && {
        float: right;
        position: relative;
        height: 120px;
        margin-right: 0;
    }

    && button {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 160px;
    }

    @media (max-width: ${mx.min}px) {
        && {
            height: fit-content;
        }

        && button {
            position: relative;
        }
    }
`;

const FilterFields = styled.div`
    && {
        margin-bottom: 0px;

        .outsideContainer, .rs-form-group, .rs-checkbox {
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }
`;

const GroupsContainer = styled(FormGroup)`
    && {
        margin-bottom: 0px;
        padding-left: 10px;
    }  
`;
